import React from "react";
import { useLocation } from "react-router-dom";
import Footer from "../components/Footer";

const ThankYou = () => {
  const location = useLocation();
  return (
    <>
      <Footer />
      <div className="bg-ty p-relative">
        <div className="ty-maxw">
          <div className="nose">
            <p className="ty-header">Agendamos tu Test Drive correctamente</p>
            <img src="./img/linea-ty.svg" alt="Vector" />
          </div>
          <p className="ty-text">
            Recordá que lo agendaste para el día{" "}
            <span>{location.state.fecha}</span> a las{" "}
            <span>{location.state.hora}h</span>, en el concesionario{" "}
            <span>{location.state.concesionario}</span>
          </p>
          <p className="ty-footer">¡Gracias por participar!</p>
        </div>
        <img
          src="./img/ty-vector.svg"
          alt="vector"
          className="p-absolute"
          style={{ bottom: 0, left: 0, maxWidth: "100%" }}
        />
      </div>
    </>
  );
};

export default ThankYou;
